import { FilterBadge } from 'models/filter';
import { useTranslation } from 'react-i18next';
import { queryParams } from 'utils/query';
import { PriorityMap } from 'utils/worklist';

export const useBadges = (): FilterBadge[] => {
  const { t } = useTranslation();

  const badges: FilterBadge[] = [
    {
      queryParameter: queryParams.priority,
      label: t('priority_label'),
      renderValue: (value: string) =>
        t(Object.values(PriorityMap).find((p) => p.filter === value)?.label || 'unknown_label'),
    },
  ];

  return badges;
};
